import { BASE_ROUTE } from '../../../../config';
import { QRCodeSVG } from 'qrcode.react';
import { useRef } from 'react';

interface QRCodePopupProps {
    article: string,
    name: string,
    close: () => void
}

const print = (container: HTMLDivElement | null) => {
    if (!container) {
        return;
    }
    const printWindow = window.open('');
    if (!printWindow) {
        return;
    }
    printWindow.document.write(container.outerHTML);
    printWindow.document.write(`<style>
        .product-catalog-close, .product-qr__buttons {
            display: none;
        }
    </style>`);
    printWindow.print();
    printWindow.close();
};
const save = (container: HTMLDivElement | null, article: string) => {
    if (!container) {
        return;
    }
    const svg = container.querySelector('.product-qr__code svg');
    if(!svg){
        return;
    }
    const serializer = new XMLSerializer();
    let source = serializer.serializeToString(svg);

    if(!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)){
        source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
    }
    if(!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)){
        source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
    }

    source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

    const url = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(source);
    const link = document.createElement('a');
    link.href = url;
    link.download = article + '.svg';
    link.click();
};
function QRCodePopup({ article, name, close }: QRCodePopupProps) {
    const link = window.location.protocol + '//' + window.location.host + BASE_ROUTE + '/article/' + article;
    const ref = useRef<HTMLDivElement>(null);
    return <div className='product-qr__wrapper' onClick={close}>
        <div className='product-qr__container' onClick={e => e.stopPropagation()} ref={ref}>
            <div className='product-catalog-close' onClick={close} />
            <h3>{name}</h3>
            <div>Артикул: {article}</div>
            <div className='product-qr__code'>
                <QRCodeSVG value={link} />
            </div>
            <div className='product-qr__buttons'>
                <div className='ui-button' onClick={() => print(ref.current)}>РАСПЕЧАТАТЬ</div>
                <div className='ui-button' onClick={() => save(ref.current, article)}>СОХРАНИТЬ</div>
            </div>
        </div>
    </div>;
}

export default QRCodePopup;
